import { isString } from 'lodash/fp'

export const isNonEmptyString = (value: unknown): value is string =>
  !!value && isString(value)
